/* eslint-disable no-undef */

import { Platform, StyleSheet } from 'react-native';
import { fontInPercentage, widthInPercentage } from '../../../utils/appUtils';

export default StyleSheet.create({
  otpContainerStyle1: {
    flexDirection: 'row',
    marginVertical: '2%',
    // flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  overdueOtpContainer: {
    flexDirection: 'row',
    marginVertical: '2%',
    justifyContent: 'start',
  },
  mobileContainerStyle1: {
    //width: '50%',
    flexDirection: 'row',
    marginVertical: 20,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  mobileContainerStyle1: {
    display: 'flex',
    flexDirection: 'row'
  },
    mobileContainerStyle1_XXXHDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyle1_XXHDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyle1_XHDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyle1_HDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyle1_MDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyle1_LDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  otpStyle: {
    padding: '4%',
    margin: 12,
    fontSize: Platform.OS === 'web' ? 30 : fontInPercentage(6),
    width: Platform.OS === 'web' ? 80 : widthInPercentage(9),
    shadowColor: '#000',
    shadowOffset: {
      width: 5,
      height: 5
    },
    shadowOpacity: 0.13,
    shadowRadius: 8,
    elevation: 6,
    textAlign: 'center',
    borderRadius: 9,
    fontWeight: '500',
    fontFamily: 'Mulish'
  },
  otpStyle_HDPI: {
    width: 50
  },
  otpStyle_MDPI: {
    margin: 0,
    width: '15%',
    paddingTop: '3%',
    paddingBottom: '3%',
    paddingRight: 0,
    paddingLeft: 0
  },
  otpStyle_LDPI: {
    margin: 0,
    width: '15%',
    paddingTop: '3%',
    paddingBottom: '3%',
    paddingRight: 0,
    paddingLeft: 0
  },
  mobilenootpStyle: {
    backgroundColor: '#fff',
    margin: 8,
    fontSize: Platform.OS === 'web' ? 30 : fontInPercentage(6),
    width: Platform.OS === 'web' ? 70 : widthInPercentage(9),
    shadowColor: '#000',
    shadowOffset: {
      width: 5,
      height: 5
    },
    shadowOpacity: 0.13,
    shadowRadius: 8,
    elevation: 6,
    textAlign: 'center',
    paddingTop: '3%',
    paddingBottom: '2%',
    paddingRight: '2%',
    paddingLeft: '2%',
    borderRadius: 9,
    fontWeight: '500',
    fontFamily: 'Mulish'
  },
  mobilenootpStyle_LDPI: {
    margin: 0,
    width: Platform.OS === 'web' ? 25 : widthInPercentage(9),
    paddingTop: '3%',
    paddingBottom: '3%',
    paddingRight: 0,
    paddingLeft: 0
  },
  mobilenootpStyle_MDPI: {
    margin: 0,
    width: Platform.OS === 'web' ? 29 : widthInPercentage(9),
    paddingTop: '3%',
    paddingBottom: '3%',
    paddingRight: 0,
    paddingLeft: 0
  },
  mobilenootpStyle_HDPI: {
    margin: 5,
    width: Platform.OS === 'web' ? 30 : widthInPercentage(9)
  },
  mobilenootpStyle_XHDPI: {
    margin: 6,
    width: Platform.OS === 'web' ? 42 : widthInPercentage(9)
  },
  mobilenootpStyle_XXHDPI: {
    margin: 6,
    width: Platform.OS === 'web' ? 50 : widthInPercentage(9)
  },
  mobilenootpStyle_XXXHDPI: {
    margin: 10,
    width: Platform.OS === 'web' ? 60 : widthInPercentage(9)
  },

  // ------------------------------------------------------------

  otpStyleMobile: {
    backgroundColor: '#fff',
    margin: 8,
    fontSize: Platform.OS === 'web' ? 30 : fontInPercentage(10),
    width: Platform.OS === 'web' ? 75 : widthInPercentage(9),
    shadowColor: '#000',
    shadowOffset: {
      width: 5,
      height: 5
    },
    shadowOpacity: 0.13,
    shadowRadius: 8,
    elevation: 6,
    textAlign: 'center',
    padding: '4%',
    borderRadius: 9,
    fontWeight: '500',
    fontFamily: 'Mulish'
  },
  otpStyleMobile_LDPI: {
    width: 37,
    padding: 8,
    fontSize: 24,
    margin: 5
  },
  otpStyleMobile_MDPI: {
    width: 37,
    padding: 10,
    fontSize: 24,
    margin: 6
  },
  otpStyleMobile_HDPI: {
    width: 40,
    padding: 10,
    fontSize: 24
  },
  otpStyleMobile_XHDPI: {
    margin: 6,
    width: Platform.OS === 'web' ? 35 : widthInPercentage(9),
    fontSize: fontInPercentage(25)
  },
  otpStyleMobile_XXHDPI: {
    margin: 6,
    width: Platform.OS === 'web' ? 50 : widthInPercentage(9)
  },
  otpStyleMobile_XXXHDPI: {
    margin: 10,
    width: Platform.OS === 'web' ? 60 : widthInPercentage(9)
  },

  // -------------------------------------------------------------
  // ------------------------------------------------------------
  overdueOtpStyle: {
    width: '56px',
    height: '56px',
    backgroundColor: '#FFFFFF',
    border: ' 2px solid balck',
    borderRadius: '8px',
    margin: 5,
    textAlign: 'center',
  },
  overdueOtpStyle_MDPI: {
    width: '45px',
    backgroundColor: '#FFFFFF',
    border: ' 2px solid balck',
    borderRadius: '8px',
    margin: 8,
    textAlign: 'center',
  },

  mobileinputbox: {
    alignItems: 'center'
  },

  mobileinputbox: {
    alignItems: 'center'
  },

  otpContainerStyle2_XXHDPI: {
    flexDirection: 'row'
  },
  otpContainerStyle2_XHDPI: {
    flexDirection: 'row'
  },
  otpContainerStyle2_HDPI: {
    flexDirection: 'row'
  },
  otpContainerStyle2_MDPI: {
    flexDirection: 'column'
  },
  otpContainerStyle2_LDPI: {
    flexDirection: 'column'
  },
  TopsectionMainViewtopnavmob: {
    padding: 10,
    paddingTop: 20,
    paddingBottom: 20
  },
  TopsectionMainViewtopnavmob_LDPI: {
    padding: 10,
    paddingTop: 10,
    paddingBottom: 10,
    width: '50%'
  },
  TopsectionMainViewtopnavmob_MDPI: {
    padding: 10,
    paddingTop: 10,
    paddingBottom: 10,
    width: '57%'
  },
  TopsectionMainViewtopnavmob_HDPI: {
    padding: 10,
    paddingTop: 10,
    paddingBottom: 10
  },
  TopsectionMainView: {
    padding: 10,
    // paddingTop: 20,
    // paddingBottom: 20
  },
  TopsectionMainView_LDPI: {
    padding: 5,
    paddingTop: 0,
    paddingBottom: 10,
    // width: '57%'
  },
  TopsectionMainView_MDPI: {
    padding: 10,
    paddingTop: 0,
    paddingBottom: 10,
  },
  TopsectionMainView_HDPI: {
    padding: 10,
    paddingTop: 10,
    paddingBottom: 10
  },
  TopsectionsecondView: {
    flexDirection: 'row'
  },
  TopsectionInnerView: {
    flex: 1,
    alignItems: 'flex-start',
    alignSelf: 'center'
  },
  TopsectionTextStyle: {
    fontSize: 32,
    fontFamily: 'Mulish',
    fontWeight: '900',
    color: '#101d6c'
  },
  TopsectionTextStyle_LDPI: {
    fontSize: 18
  },
  TopsectionTextStyle_MDPI: {
    fontSize: 22
  },
  TopsectionTextStyle_HDPI: {
    fontSize: 22
  },
  TopsectionTextStyle_XHDPI: {
    fontSize: 24
  },
  TopsectionTextStyle_XXHDPI: {
    fontSize: 26
  },
  TopsectionTextStyle_XXXHDPI: {
    fontSize: 28
  },
  TopsectionthirdtextView: {
    flex: 1,
    alignItems: 'flex-end',
    paddingLeft: 10
  },
  TopsectionthirdtextView_XXHDPI: {
    flex: 1,
    alignItems: 'flex-end',
    paddingLeft: 10,
    justifyContent: 'center'
  },
  TopsectionthirdtextView_XXXHDPI: {
    flex: 1,
    alignItems: 'flex-end',
    paddingLeft: 10,
    justifyContent: 'center'
  },
  TopsectionthirdtextView_LDPI: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  TopsectionthirdtextView_MDPI: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  TopsectionthirdtextView_HDPI: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  TopsectionthirdtextView2: {
    flexDirection: 'row'
  },
  Topsectionthirdtextstyle: {
    marginLeft: 3,
    fontSize: 16,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#ff6600'
  },
  Topsectionthirdtextstyle_LDPI: {
    marginLeft: 3,
    fontSize: 10,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#ff6600'
  },
  Topsectionthirdtextstyle_MDPI: {
    marginLeft: 3,
    fontSize: 10,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#ff6600'
  },
  Topsectionthirdtextstyle_HDPI: {
    marginLeft: 3,
    fontSize: 12
  },
  Topsectionthirdtextstyle_XHDPI: {
    marginLeft: 3,
    fontSize: 12
  },
  Topsectionthirdtextstyle_XXHDPI: {
    marginLeft: 3,
    fontSize: 12
  },
  Topsectionthirdtextstyle_XXXHDPI: {
    marginLeft: 3,
    fontSize: 16
  },
  TopsectionAutocompleteView: {
    flex: 1
  },
  TopsectionAutocompleteView_LDPI: {
    flex: 1,
    marginTop: 8
  },
  TopsectionAutocompleteView_MDPI: {
    flex: 1,
    marginTop: 8
  },
  TopsectionAutocompleteView_HDPI: {
    flex: 1,
    marginTop: 8
  },
  TopsectionAutocompleteView_XHDPI: {
    flex: 1,
    marginTop: 8
  },
  TopsectionAutocompleteView2: {
    height: 41,
    border:"1px solid #fffff",
    borderRadius: 21,
    backgroundColor: '#feeed3',
    borderTop:'1px solid black',
    boxShadow: 'inset 0 0 0 .1rem #000',
    paddingHorizontal:widthInPercentage(2.5),
    // justifyContent:'center',
    marginBottom: widthInPercentage(1.4),
    // paddingLeft:'7%',
    alignItems:'center',
    display:'flex',
    flexDirection:'row',
  },
  TopsectionAutocompleteView3: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
  },
  TopsectionAutocompleteView3_XXXHDPI: {
    width: '100%'
  },
  TopsectionAutocompleteView3_XXHDPI: {
    width: '100%'
  },
  TopsectionAutocompleteIMageView: {
    width: '6%'
  },
  TopsectionAutocompleteIMagestyle: {
    width: 20,
    height: 20
  },
  TopsectionAutocompleteIMagestyle22: {
    width: 20,
    height: 20
  },
  TopsectionAutocompleteIMagestyle_LDPI: {
    width: 30,
    height: 30
  },
  TopsectionAutocompleteIMagestyle_MDPI: {
    width: 30,
    height: 30
  },
  TopsectionAutocompleteIMagestyle_HDPI: {
    width: 30,
    height: 30
  },
  TopsectionAutocompleteIMagestyle11: {
    width: 30,
    height: 30
  },
  TopsectionAutocompletestyle: {
    fontFamily: 'Mulish',
    fontSize: 16
  },
  TopsectionAutocompletestyle_LDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    paddingTop: 3,
    paddingBottom: 3
  },
  TopsectionAutocompletestyle_MDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    paddingTop: 3,
    paddingBottom: 3
  },
  TopsectionAutocompletestyle_HDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    paddingTop: 3,
    paddingBottom: 3
  },
  TopsectionAutocompleteButtonstyle: {
    borderBottomWidth: 0.5,
    borderColor: '#dadada',
    flexDirection:'row'
  },
  TopsectionAutocompleteButtontextstyle: {
    paddingVertical: 15,
    paddingHorizontal: 15,
    fontFamily: 'Mulish',
    color: '#101d6c'
  },
  TopsectionAutocompleteServicetextstyle: {
    paddingVertical: 15,
    paddingHorizontal: 1,
    fontFamily: 'Mulish',
    color: '#101d6c'
  },
  TopsectionAutocompletemenutextstyle: {
    paddingVertical: 15,
    paddingLeft: 20,
    fontFamily: 'Mulish',
    justifyContent: 'center',
    color: '#101d6c'
  },
  TopsectionAutocompletemenutextstyle_LDPI: {
    //paddingVertical: 4,
    //paddingLeft: 5,
    fontFamily: 'Mulish',
    // justifyContent: 'center',
    color: '#101d6c'
  },
  TopsectionAutocompleteButtontextstyle_LDPI: {
    //paddingLeft: 20,
    // paddingVertical: 1,
    // paddingHorizontal: 1,
    fontFamily: 'Mulish',
    color: '#101d6c'
  },
  TopsectionAutocompleteButtontextstyle_MDPI: {
    //paddingLeft: 20,
    // paddingVertical: 1,
    // paddingHorizontal: 1,
    fontFamily: 'Mulish',
    color: '#101d6c'
  },
  inputBlockInnerView: {
    marginTop: 10,
    flexDirection: 'row'
  },
  inputBlockInnerViewColumn: {
    marginVertical: 5
  },
  aadharBlockInnerView: {
    flex: 1,
    marginTop: 10,
    flexDirection: 'row'
  },

  TextInputstyleOne: {
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    width: 250,
    backgroundColor: 'white',
    padding: 5,
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6,
    marginBottom: 10,
    borderRadius: 8
  },

  TextInputstyle1: {
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    width: 250,
    backgroundColor: 'white',
    padding: '7%',
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 8
  },
  TextInputstyle1_HDPI: {
    fontSize: 25,
    width: 150
  },
  TextInputstyle1_MDPI: {
    fontSize: 15,
    width: 120,
    padding: Platform.OS === 'web' ? '3%' : 0,
    height: 200
  },
  TextInputstyle1_LDPI: {
    fontSize: 15,
    width: 100,
    padding: Platform.OS === 'web' ? '3%' : 0,
    height: 170
  },
  TextInputstyle2: {
    borderRadius: 8,
    width: 250,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    padding: '7%',
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6
  },
  TextInputstyleTwo: {
    borderRadius: 8,
    width: 180,
    color: 'black',
    marginBottom: 10,
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    padding: 5,
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6
  },
  TextInputstyle2_HDPI: {
    fontSize: 25,
    width: 150
  },
  TextInputstyle2_MDPI: {
    fontSize: 15,
    width: 120
  },
  TextInputstyle2_LDPI: {
    fontSize: 15,
    width: 100
  },
  TextInputstyle3: {
    borderRadius: 8,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    width: 70,
    backgroundColor: 'white',
    padding: '22%',
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6
  },
  TextInputstyleThree: {
    borderRadius: 8,
    color: 'black',
    marginLeft: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '2%',
    textAlign: 'center',
    width: 60,
    backgroundColor: 'white',
    fontSize: 30,
    height: Platform.OS !== 'web' ? 50 : 46,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1
    },
    shadowOpacity: 0.5,
    shadowRadius: 4.65,
    elevation: 6
  },
  TextInputstyle3_HDPI: {
    fontSize: 25,
    width: 50,
    padding: '19%'
  },
  TextInputstyle3_MDPI: {
    fontSize: 15,
    width: 45,
    padding: '21%'
  },
  TextInputstyle3_LDPI: {
    fontSize: 15,
    width: 40
  },
  serviceContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  serviceBox: {
    width: '100%',
    //height: 80,
    justifyContent: 'center',
    //shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 4,
    padding: 10,
    height: 108,
    paddingBottom: 0, 
    paddingRight: 0,
    paddingLeft: 2
  },
  serviceBox_XXHDPI: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 8,
    padding: 0
  },
  serviceBoxATM: {
    width: '100%',
    //height: 80,
    justifyContent: 'center',
    //shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 4,
    padding: 10,
    //height: 103,
    paddingBottom: 0, paddingRight: 0,
    paddingLeft: 2
  },
  serviceTextView: {
    justifyContent: 'center',
    textAlign: 'left'
  },
  serviceTextView_LAPTOP: { flex: 3, justifyContent: 'center' },
  serviceTextView_XXHDPI: {
    flex: 3,
    justifyContent: 'center',
    textAlign: 'center',
    padding: 10
  },
  serviceTextView_MDPI: {
    marginLeft: widthInPercentage(3)
    // justifyContent: 'center',
    // textAlign: 'center'
  },
  serviceTextView_XXXHDPI: {
    flex: 3,
    justifyContent: 'center',
    textAlign: 'center'
  },
  serviceText: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    fontSize: 16,
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceLeftText:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    color: '#222222',
    textAlign: 'left',
    fontSize: 13,
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceLeftText_XXHDPI:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    color: '#222222',
    textAlign: 'left',
    fontSize: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceDescText:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    textAlign: 'left',
    fontSize: 10,
    alignItems: 'center',
    justifyContent: 'center',
    color: '#7b7b7b'
  },
  serviceDescText_XXHDPI:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    textAlign: 'left',
    fontSize: 8,
    alignItems: 'center',
    justifyContent: 'center',
    color: '#7b7b7b'
  },
  serviceText_XXHDPI: {
    fontSize: 16
  },
  serviceText_XXXHDPI: {
    fontSize: 16
  },
  serviceText_XHDPI: {
    fontSize: 14
  },
  serviceText_HDPI: {
    fontSize: 14
  },
  serviceText_MDPI: {
    fontSize: 14
  },
  serviceText_LDPI: {
    fontSize: 14
  },
  serviceBoxPadding: {
    padding: 10
  },
  serviceText_LDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_MDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_HDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_XHDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_XXHDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_XXXHDPI: {
    fontFamily: 'Mulish',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center'
  },

  serviceBoxPadding_LDPI: {
    padding: 10
  },
  serviceBoxPadding_MDPI: {
    padding: 10
  },
  serviceBoxPadding_HDPI: {
    padding: 10
  },
  serviceBoxPadding_XHDPI: {
    padding: 8
  },
  serviceBoxPadding_XXHDPI: {
    padding: 10
  },
  serviceBoxPadding_XXXHDPI: {
    padding: 15
  },
  serviceBox_LDPI: {
    width: '100%',
    height: 60,
    padding: 5,
    borderRadius: 10
  },
  serviceBox_MDPI: {
    width: '100%',
    padding: 15,
    height: 65,
    borderRadius: 10
  },
  serviceBox_HDPI: {
    width: '100%',
    height: 70,
    padding: 23,
    borderRadius: 10
  },
  serviceBox_XHDPI: {
    width: '100%',
    padding: 15,
    borderRadius: 3,
    height: 100
  },
  serviceBox_XXHDPI: {
    width: '100%',
    padding: 5,
    borderRadius: 0
  },
  serviceBox_XXXHDPI: {
    width: '100%',
    padding: 25,
    borderRadius: 10
  },

  serviceContent_XHDPI: {
    width: '100%',
    alignItems: 'center'
  },
  serviceContent_MDPI: {
    flex: 1,
    justifyContent: 'center'
  },
  serviceContent_LDPI: {
    flex: 1,
    justifyContent: 'center'
  },
  serviceContent_HDPI: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },

  serviceContent_XXHDPI: {
    width: '100%',
    alignItems: 'center'
  },
  serviceContent_XXXHDPI: {
    width: '100%',
    alignItems: 'center'
  },
  optionText: {
    marginLeft: 15,
    fontSize: 20,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  optionText_LDPI: {
    marginLeft: '3%',
    fontSize: 18,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  optionText_MDPI: {
    marginLeft: '3%',
    fontSize: 18,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  optionText_XXHDPI: {
    marginLeft: 10,
    fontSize: 18,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  optionText_XHDPI: {
    marginLeft: 5,
    fontSize: 18,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  optionText_HDPI: {
    marginLeft: '16%',
    fontSize: 18,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: '#000000'
  },
  sideBardView: {
    width: '40%'
  },
  sideBardView_XXXHDPI: {
    width: '20%'
  },
  LeftsidebarBtn1style: {
    width: '95%',
    // height: 65,
    // paddingTop: 25,
    // paddingBottom: 25,
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 25,
    overflow: 'visible',
    maxHeight: 100
  },
  LeftsidebarBtn1style_XXXHDPI: {
    width: '95%',
    // height: 60,
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 25,
    overflow: 'visible',
    maxHeight: 100
  },
  LeftsidebarBtn1style_LAPTOP: {
    width: '95%',
    // height: 60,
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 25,
    overflow: 'visible',
    maxHeight: 100
  },
  LeftsidebarBtn1style_XXHDPI: {
    width: '100%',
    //  height: 60,
    flexDirection: 'row',
    backgroundColor: '#fcebd6'
  },
  LeftsidebarBtn2style: {
    width: '100%',
    paddingTop: 25,
    paddingBottom: 25,
    flexDirection: 'row',
    backgroundColor: '#fff',
    maxHeight: 100
  },
  LeftsidebarBtn2style_XXXHDPI: {
    width: '100%',
    // height: 60,
    flexDirection: 'row'
  },
  LeftsidebarBtn2style_XXHDPI: {
    width: '100%',
    // height: 60,
    flexDirection: 'row'
  },
  LeftsidebarBtn2Textstyle: {
    fontFamily: 'Mulish',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.56,
    //fontWeight: 'bold',
    color: '#222222'
  },
  LeftsidebarBtn2Textstyle_XXXHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '500'
  },
  LeftsidebarBtn2Textstyle_XHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '500'
  },
  LeftsidebarBtn2Textstyle_XXHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '500'
  },
  LeftsidebarBtn1Textstyle: {
    fontFamily: 'Mulish',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.56,
    fontWeight: 'bold',
    color: '#222222'
  },
  LeftsidebarBtn1Textstyle_XXXHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: 'bold'
  },
  LeftsidebarBtn1Textstyle_XXHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: 'bold'
  },
  LeftsidebarBtn1Textstyle_XHDPI: {
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: 'bold'
  },
  LeftsidebarBtn1ImagePaddingstyle: {
    paddingLeft: 15,
    paddingRight: 30
  },
  LeftsidebarBtn1ImagePaddingstyle_XXXHDPI: {
    paddingLeft: 10,
    paddingRight: 10
  },
  LeftsidebarBtn1ImagePaddingstyle_XXHDPI: {
    paddingLeft: 10,
    paddingRight: 10
  },
  LeftsidebarBtn1Imagestyle: {
    width: 20,
    height: 20
  },
  LeftsidebarBtn1Imagestyle_LAPTOP: {
    width: 30,
    height: 30
  },
  LeftsidebarBtnMainView: {
    width: 5,
    height: 65,
    backgroundColor: '#FF4500'
  },
  LeftsidebarBtnMainView2: {
    width: 5,
    height: 65,
    backgroundColor: '#fff'
  },
  LeftsidebarBtn2innerstyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    // marginLeft: '15%'
  },
  LeftsidebarMainView: {
    zIndex: 1
  },
  LeftsidebarInnerView: {
    flexDirection: 'column',
    backgroundColor: '#fff'
  },
  TopnavMainview: {
    height: 60,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 5
  },
  TopnavMainview2: {
    //flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  TopnavMainview3: {
    flex: 1,
    alignItems: 'flex-start',
    marginLeft: 10
  },
  TopnavMainview3topnavmob: {
    flex: 1,
    alignItems: 'flex-start',
    marginLeft: 10
  },
  TopnavMainview3topnavmob_MDPI: {
    flex: 1,
    alignItems: 'flex-start',
    marginLeft: 7
  },
  TopnavMobileMenuicon: {
    width: 30,
    height: 30
  },
  TopnavMobileCloseicon: {
    width: 20,
    height: 20
  },
  TopnavMobileLogoView: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 10
  },
  TopnavMobileLogostyle: {
    width: 140,
    height: 60
  },
  TopnavMobilemenuOpenDarkView: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)'
  },
  TopnavMobilemenuOpenMainView: {
    height: Platform.OS === 'web' ? '100vh' : 1200,
    width: '95%',
    backgroundColor: 'white',
    top: -60
  },
  TopnavMobilemenuOpenMainView2: {
    paddingTop: 10,
    paddingLeft: 10
  },
  TopnavMobilemenulogoView: {
    paddingTop: 25,
    paddingLeft: 20
  },
  TopnavMobilemenulogostyle: {
    width: 160,
    height: 80
  },
  TopnavMobilemenuUNderlineView: {
    paddingTop: Platform.OS == 'web' ? null : 30
  },
  TopnavMobilemenuUNderlinestyle: {
    borderTopColor: '#D3D3D3',
    borderTopWidth: 1
  },
  TopnavMobilemenuUNderlinestyle_LDPI: {
    borderTopColor: '#D3D3D3',
    borderTopWidth: 0
  },
  TopnavMobilemenuUNderlinestyle_MDPI: {
    borderTopColor: '#D3D3D3',
    borderTopWidth: 0
  },
  TopnavMobilemenuUNderlinestyle_HDPI: {
    borderTopColor: '#D3D3D3',
    borderTopWidth: 0
  },
  TopnavMobilemenureqMinView: {},
  TopnavMobilemenureqMinView2: {
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 2,
    alignItems: 'center'
  },
  TopnavMobilemenureqMinView2_MDPI: {
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 56,
    alignItems: 'center'
  },
  TopnavMobilemenureqMinView2_LDPI: {
    flexDirection: 'row',
    backgroundColor: '#fcebd6',
    borderRadius: 56,
    alignItems: 'center'
  },
  TopnavMobilemenureqMinView3: {
    flexDirection: 'row',
    borderRadius: 2,

    alignItems: 'center'
  },
  TopnavMobilemenureqMinbtn1style: {
    flexDirection: 'row'
  },
  TopnavMobilemenureqMinimage1style: {
    width: 25,
    height: 25
  },
  TopnavMobilemenureqMinTextViewstyle: {
    paddingLeft: 5,
    alignSelf: 'center'
  },
  TopnavMobilemenureqMinText1style: {
    color: '#22222',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 16
  },
  TopnavMobilemenureqMinText2style: {
    color: '#333',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 16
  },
  TopnavMobilemenureqMinbtn1PaddingView: {
    paddingHorizontal: 15,
    justifyContent: 'center'
  },
  //otp
  dobHeading: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: '10%',
    fontSize: 35,
    marginTop: '5%',
    fontFamily: 'Mulish'
  },
  dobHeading_MDPI: {
    fontSize: 20
  },
  dobHeading_LDPI: {
    fontSize: 20
  },
  Resendotptxt: {
    color: '#fff',
    fontSize: 15,
    fontWeight: 'bold',
    fontFamily: 'Mulish'
  },
  Resendotp: {
    backgroundColor: '#101d6c',
    padding: '2%',
    // marginBottom: 10,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center'
  },

  Updatebuttonresend: {
    backgroundColor: '#e77817',
    borderRadius: 5,
    padding: 5
  },
  Updatebutton_LDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },
  Updatebutton_MDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },
  Updatebutton_HDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },

  Updatebuttontxtresend: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'normal',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  Updatebuttontxt_XXHDPI: { fontSize: 20 },
  Updatebuttontxt_XHDPI: { fontSize: 18 },
  Updatebuttontxt_HDPI: { fontSize: 16 },
  Updatebuttontxt_MDPI: { fontSize: 16 },
  Updatebuttontxt_LDPI: { fontSize: 14 },
  maintextendotp: {
    alignItems: 'center'
  },
  textendotp: {
    paddingTop: 48,
    fontSize: 30,
    fontFamily: 'Mulish',
    textAlign: 'center'
  },
  textendotp_LDPI: {
    paddingTop: 25,
    fontSize: 20
  },
  textendotp_MDPI: {
    paddingTop: 25,
    fontSize: 20
  },
  textendotp_HDPI: {
    paddingTop: 28,
    fontSize: 18
  },
  textendotp_XHDPI: {
    paddingTop: 28,
    fontSize: 25
  },
  textendotp_XXHDPI: {
    paddingTop: 48,
    fontSize: 25
  },
  textmiddlemobile_XXXHDPI: {
    paddingTop: 48,
    fontSize: 25
  },
  dobSubHeading: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: '10%',
    fontSize: 25,
    marginTop: '2%',
    fontFamily: 'Mulish'
  },
  dobSubHeading_MDPI: {
    fontSize: 15
  },
  dobSubHeading_LDPI: {
    fontSize: 15
  },
  //Mobile
  boxmobile: {
    backgroundColor: 'white',
    width: 750,
    borderRadius: 16,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    justifyContent: 'center',
    fontFamily: 'Mulish',
    padding: 20
  },
  headertextcombined: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  textheadermobile: {
    paddingBottom: 18,
    fontSize: 35,
    fontFamily: 'Mulish',
    alignItems: 'flex-start'
  },
  textmiddlemobile: {
    fontSize: 25,
    fontFamily: 'Mulish',
    alignItems: 'flex-start'
  },
  mobiletextandbox: {
    paddingBottom: 25,
    alignItems: 'center',
    justifyContent: 'center'
  },
  textendmobile: {
    paddingTop: 40,
    fontSize: 30,
    fontFamily: 'Mulish'
  },
  boxmobile_LDPI: {
    backgroundColor: '#fff',
    width: 300,
    padding: 10
  },
  boxmobile_MDPI: {
    backgroundColor: '#fff',
    width: 345
  },
  boxmobile_HDPI: {
    backgroundColor: '#fff',
    width: 470
  },
  boxmobile_XHDPI: {
    backgroundColor: '#fff',
    width: 610
  },
  boxmobile_XXHDPI: {
    backgroundColor: '#fff',
    width: 750
  },
  boxmobile_XXXHDPI: {
    backgroundColor: '#fff',
    width: 750
  },
  textmiddlemobile_LDPI: {
    fontSize: 15
  },
  textmiddlemobile_MDPI: {
    fontSize: 20
  },
  textmiddlemobile_HDPI: {
    fontSize: 18
  },
  textmiddlemobile_XHDPI: {
    fontSize: 21
  },
  textmiddlemobile_XXHDPI: {
    fontSize: 25
  },
  textmiddlemobile_XXXHDPI: {
    fontSize: 25
  },
  textendmobile_LDPI: {
    fontSize: 20
  },
  textendmobile_MDPI: {
    fontSize: 20
  },
  textendmobile_HDPI: {
    fontSize: 20
  },
  textendmobile_XHDPI: {
    fontSize: 25
  },
  textendmobile_XXHDPI: {
    fontSize: 25
  },
  textendmobile_XXXHDPI: {
    fontSize: 25
  },
  textheadermobile_LDPI: {
    fontSize: 30
  },
  textheadermobile_HDPI: {
    fontSize: 30
  },
  headertextcombined_HDPI: {
    paddingLeft: '5%'
  },
  headertextcombined_LDPI: {
    paddingLeft: '5%'
  },

  otpContainerStyle: {
    width: '50%',
    flexDirection: 'row',
    flex: 1
  },
  otpContainerStyle_XXHDPI: {
    width: '100%'
  },
  otpContainerStyle_XHDPI: {
    flexDirection: 'column',
    width: '100%'
  },
  otpContainerStyle_HDPI: {
    flexDirection: 'column',
    width: '100%'
  },
  otpContainerStyle_MDPI: {
    flexDirection: 'column',
    width: '100%'
  },
  otpContainerStyle_LDPI: {
    flexDirection: 'column',
    width: '100%'
  },
  otpContainerView: {
    flexDirection: 'row'
  },
  hypen: {
    marginTop: 12
  },
  TopNavImage1MainView: {
    marginLeft: 10,
    flex: 1
  },
  TopNavImage1StyleView: {
    resizeMode: 'contain',
    marginLeft: 10,
    width: 200,
    //height: 72
  },
  TopNavImage1StyleView_XXHDPI: {
    resizeMode: 'contain',
    width: 160,
    height: 70
  },
  TopNavImage1StyleView_XHDPI: {
    resizeMode: 'contain',
    width: 140,
    height: 70
  },
  TopNavImage1StyleView_HDPI: {
    resizeMode: 'contain',
    width: 136,
    height: 72
  },
  TopNavImage1StyleView_MDPI: {
    resizeMode: 'contain',
    width: 130,
    height: 72
  },
  TopNavImage1StyleView_LDPI: {
    resizeMode: 'contain',
    width: 114,
    height: 60
  },
  TopNavDropdownMainView: {
    //marginLeft: 10,
    paddingTop: 15,
    flex: 2
  },
  TopNavDropdownMainView_HDPI: {
    paddingTop: 20,
    flex: 2
  },
  TopNavDropdownMainView_MDPI: {
    paddingTop: 20,
    flex: 2
  },
  TopNavDropdownMainView_LDPI: {
    paddingTop: 22,
    // paddingRight: 12,
    flex: 2
  },
  TopNavDropdownImgView: {
    resizeMode: 'contain',
    marginLeft: 10,
    width: 200,
    height: 72
  },
  TopNavDropdownImgView_XXHDPI: {
    resizeMode: 'contain',
    width: 160,
    height: 70
  },
  TopNavDropdownImgView_XHDPI: {
    resizeMode: 'contain',
    width: 71,
    height: 21
  },
  TopNavDropdownImgView_HDPI: {
    resizeMode: 'contain',
    width: 71,
    height: 14,
    paddingTop: 10,
    marginTop: '16%'
  },
  TopNavDropdownImgView_MDPI: {
    resizeMode: 'contain',
    width: 71,
    height: 14,
    paddingTop: 10,
    marginTop: '16%'
  },
  TopNavDropdownImgView_LDPI: {
    resizeMode: 'contain',
    width: 71,
    height: 14,
    paddingTop: 10,
    marginTop: '16%'
  },
  TopNavDropdownImgViewhomescreen: {
    resizeMode: 'contain',
    marginLeft: 10,
    width: 200,
    height: 72
  },
  TopNavDropdownImgViewhomescreen_XXHDPI: {
    resizeMode: 'contain',
    width: 160,
    height: 70
  },
  TopNavDropdownImgViewhomescreen_XHDPI: {
    resizeMode: 'contain',
    width: 71,
    height: 21
  },
  TopNavDropdownImgViewhomescreen_HDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  TopNavDropdownImgViewhomescreen_MDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  TopNavDropdownImgViewhomescreen_LDPI: {
    resizeMode: 'contain',
    width: 48,
    height: 14,
    paddingTop: 10,
    marginTop: '3%'
  },
  newTopNavMainView: {
    width: '100%',
    backgroundColor: '#fff',
    shadowOpacity: 0.1,
    shadowRadius: 18
  },
  newTopNavInnerView: {
    paddingTop: 5,
    paddingBottom: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  newTopNavbar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
    height: 40
  },
  isblur: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 4
    // pointerEvents: 'none' commented for mobile need to put seperate style
  },
  newTopNavAutoompleteMainview: {
    flex: 2
  },
  newTopNavImage2Mainview: {
    flex: 1,
    //alignItems: 'flex-end',
    alignItems: 'flex-start',
    // padding: 10,
    paddingLeft: 10
  },
  newTopNavImage2MainviewLocation: {
    flex: 1,
    //alignItems: 'flex-end',
    alignItems: 'flex-start',
    padding: 10,
    paddingLeft: 20
  },
  newTopNavImage2Mainview1: {
    flex: 0.5,
    //alignItems: 'flex-end',
    alignItems: 'flex-start',
    padding: 10,
    paddingLeft: 20
  },
  newTopNavImage2Mainview_XHDPI: {
    flex: 1,
    alignItems: 'flex-start',
    padding: 10
  },

  //email text input
  EmailInputStyle: {
    // flex: 1,
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    width: 650,
    backgroundColor: 'white',
    paddingLeft: '11%',
    paddingRight: '6%',
    paddingBottom: '4%',
    paddingTop: '4%',
    fontSize: 30,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 7
  },
  EmailInputStyle_XHDPI: {
    fontSize: 30,
    width: 600
  },
  EmailInputStyle_XXHDPI: {
    fontSize: 30,
    width: 600
  },
  EmailInputStyle_XXXHDPI: {
    fontSize: 30,
    width: 650
  },
  EmailInputStyle_HDPI: {
    fontSize: 25,
    width: 445
  },
  EmailInputStyle_MDPI: {
    paddingLeft: '15%',
    paddingRight: '6%',
    fontSize: 15,
    width: 332
  },
  EmailInputStyle_LDPI: {
    paddingLeft: '15%',
    paddingRight: '6%',
    fontSize: 15,
    width: 250
  },
  mobileContainerStyleAccno: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileContainerStyleAccno_LDPI: {
    display: 'flex',
    flexDirection: 'column'
  },
  mobileContainerStyleAccno_MDPI: {
    display: 'flex',
    flexDirection: 'column'
  },
  mobileContainerStyleAccno_HDPI: {
    display: 'flex',
    flexDirection: 'column'
  },
  mobileContainerStyleAccno_XHDPI: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobilenootpStyleaccno: {
    // backgroundColor: '#fff',
    // margin: 8,
    // fontSize: Platform.OS === 'web' ? 30 : fontInPercentage(6),
    // width: Platform.OS === 'web' ? 70 : widthInPercentage(9),
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 1,
    //   height: 1
    // },
    // shadowOpacity: 0.3,
    // shadowRadius: 8,
    // elevation: 6,
    // textAlign: 'center',
    // padding: 10,
    // paddingTop: '3%',
    // paddingBottom: '2%',
    // paddingRight: '2%',
    // paddingLeft: '2%',
    // borderRadius: 9,
    // fontWeight: '500',
    // fontFamily: 'Mulish'
    backgroundColor: '#fff',
    margin: 8,
    fontSize: Platform.OS === 'web' ? 30 : fontInPercentage(10),
    width: Platform.OS === 'web' ? 70 : widthInPercentage(9),
    shadowColor: '#000',
    shadowOffset: {
      width: 5,
      height: 5
    },
    shadowOpacity: 0.13,
    shadowRadius: 8,
    elevation: 6,
    textAlign: 'center',
    padding: '4%',
    borderRadius: 9,
    fontWeight: '500',
    fontFamily: 'Mulish'
  },
  mobilenootpStyleaccno_LDPI: {
    fontSize: Platform.OS === 'web' ? 24 : fontInPercentage(20),
    width: Platform.OS === 'web' ? 40 : widthInPercentage(9),
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    margin: 5
  },
  mobilenootpStyleaccno_MDPI: {
    fontSize: Platform.OS === 'web' ? 24 : fontInPercentage(20),
    width: Platform.OS === 'web' ? 40 : widthInPercentage(9),
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    margin: 5
  },
  mobilenootpStyleaccno_HDPI: {
    fontSize: Platform.OS === 'web' ? 24 : fontInPercentage(20),
    width: Platform.OS === 'web' ? 40 : widthInPercentage(9),
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    margin: 5
  },
  mobilenootpStyleaccno_XHDPI: {
    margin: 4,
    width: Platform.OS === 'web' ? 42 : widthInPercentage(9),
    fontSize: fontInPercentage(25)
  },
  mobilenootpStyleaccno_XXHDPI: {
    margin: 6,
    width: Platform.OS === 'web' ? 50 : widthInPercentage(9)
  },
  mobilenootpStyleaccno_XXXHDPI: {
    margin: 10,
    width: Platform.OS === 'web' ? 60 : widthInPercentage(9)
  },
  mobilenootpStylesplitViews: {
    flexDirection: 'row'
    // marginTop: 20
  },
  mobilenootpStylesplitViews_LDPI: {
    flexDirection: 'row',
    marginTop: 15
  },
  mobilenootpStylesplitViews_MDPI: {
    flexDirection: 'row',
    marginTop: 15
  },
  mobilenootpStylesplitViews_HDPI: {
    flexDirection: 'row',
    marginTop: 20
  },
  mobilenootpStylesplitViews_XHDPI: {
    flexDirection: 'row',
    marginTop: 20
  },
  TopnavMobileIPLOCATIONdet: {
    padding: 15
  },
  TopnavMobileIPLOCATIONdet_MDPI: {
    padding: 10,
  },
  TopnavMobileIPLOCATIONdettopnavmob: {
    padding: 15
  },
  TopnavMobileIPLOCATIONdettopnavmob_MDPI: {
    padding: 10,
  },
  TopnavMobileIPLOCATIONdettopnavmob_LDPI: {
    padding: 10,
    width: '100%'
  },
  TopnavMobileIPText: {
    fontSize: 14,
    fontFamily: 'Mulish',
    left: '2%'
  },
  TopnavMobileIPText_XHDPI: {
    fontSize: 12,
    fontFamily: 'Mulish'
  },
  LeftsidebarFlexAndHeight: {
    marginTop: 10,
    flex: 1,
    maxHeight: 55
  },
  LeftsidebarFlexAndHeightatm: {
    //marginTop: 4,
    flex: 1,
    maxHeight: 45
  },
  LeftsidebarFlexAndHeight_XHDPI: {
    flex: 1,
    maxHeight: 58
  },
  //dob main view -> dobpage

  mainView: {
    flexDirection: 'row',
    // marginBottom: '2%',
    width: 1000
  },
  mainView_LAPTOP: {
    flexDirection: 'row',
    // marginBottom: '2%',
    width: widthInPercentage(100)
  },
  mainView_XXXHDPI: {
    width: 900
  },
  mainView_XXHDPI: {
    width: 800
  },
  mainView_XHDPI: {
    width: 550
  },
  mainView_HDPI: {
    width: 500
  },
  mainView_LDPI: {
    width: 518,
    flexDirection: 'row',
  },
  mainView_MDPI: {
    width: 500
  },
  // dob heading View
  dobHeadingView: {
    flex: 3,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(30)
    // borderRadius: 5,
    // shadowColor: '#000',
    // marginHorizontal: '1%',
    // shadowOffset: {
    //   width: 0,
    //   height: 3
    // },
    // shadowOpacity: 0.27,
    // shadowRadius: 4.65,
    // elevation: 6,
    // backgroundColor: 'white'
  },
  dobHeadingView_XHDPI: {
    flex: 3,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(20)

  },
  dobHeadingView_XXHDPI: {
    marginHorizontal: widthInPercentage(34)
  },
  dobHeadingView_XXXHDPI: {
    flex: 3,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(36)

  },
  dobHeadingView_LAPTOP: {
    flex: 3,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(32)

  },

  // second main view
  dobSecondView: {
    flexDirection: 'row',
    width: 1000,
    height: 195,
    //marginHorizontal:widthInPercentage(40)
  },
  dobSecondView_LAPTOP: {
    flexDirection: 'row',
    width: 940,
    height: 195,
    //marginHorizontal:widthInPercentage(40)
  },
  dobSecondView_XXXHDPI: {
    width: 900
  },
  dobSecondView_XXHDPI: {
    width: 800,
    height: 254
  },
  dobSecondView_XHDPI: {
    width: 550
  },
  dobSecondView_HDPI: {
    width: 500
  },
  dobSecondView_LDPI: {
    width: 500
  },
  dobSecondView_MDPI: {
    width: 500
  },

  // dob day view
  dobDayView: {
    flexDirection: 'row',
    width: 1000,
    height: 200
  },
  dobDayView_XXXHDPI: {
    width: 900
  },
  dobDayView_LAPTOP: {
    width: 950
  },
  dobDayView_XXHDPI: {
    width: 800
  },
  dobDayView_XHDPI: {
    width: 550,
    height: 186
  },
  dobDayView_HDPI: {
    width: 500,
    height: 186
  },
  dobDayView_LDPI: {
    width: 500,
    height: 186
  },
  dobDayView_MDPI: {
    width: 500,
    height: 186
  },
  // dob arrow view
  dobArrowMainView: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  dobArrowImageMainView: {
    flex: 0.2,
    padding: 2,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  dobArrowImageMainView_XXXHDPI: {
    flex: 0.2,
    padding: 2,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  dobArrowImageMainView_XHDPI: {
    flex: 0.2,
    padding: 2,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },

  arrowRight: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  arrowRight_LDPI: {
    flex: 0.6,
    justifyContent: 'center',
    marginHorizontal: widthInPercentage(15),
    alignItems: 'center',
  },
  arrowRight_MDPI: {
    flex: 0.6,
    justifyContent: 'center',
    marginHorizontal: widthInPercentage(15),
    alignItems: 'center',
  },
  arrowRight_HDPI: {
    flex: 0.6,
    justifyContent: 'center',
    marginHorizontal: widthInPercentage(15),
    alignItems: 'center',
  },

  arrowLeft: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  arrowLeft_LDPI: {
    flex: 0.6,
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  arrowLeft_HDPI: {
    flex: 0.6,
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  arrowLeft_MDPI: {
    flex: 0.6,
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },

  // dob arrow view padding
  dobArrowPadding: {
    paddingVertical: '10%',
    paddingHorizontal: '10%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },
  dobArrowPadding_LDPI: {
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    backgroundColor: '#e2e2e2',
    borderRadius: 5
  },
  dobArrowPadding_MDPI: {
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    backgroundColor: '#e2e2e2',
    borderRadius: 5
  },
  dobArrowPadding_HDPI: {
    paddingVertical: '5%',
    paddingHorizontal: '5%',
    backgroundColor: '#e2e2e2',
    borderRadius: 5
  },

  dobDayArrowPadding: {
    padding: '5%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },

  dobDayArrow: {
    paddingVertical: '10%',
    paddingHorizontal: '20%',
    backgroundColor: '#e2e2e2',
    borderRadius: 10
  },

  loadingImagestyle: {
    width: 80,
    height: 80
  },
  flatlistStyle: { flex: 1, marginHorizontal: widthInPercentage(30) },
  flatlistStyle_LAPTOP: { flex: 1, marginHorizontal: widthInPercentage(30) },
  flatlistStyle_XXHDPI: { flex: 1, marginHorizontal: widthInPercentage(35) },
  flatlistStyle_XXXHDPI: { flex: 1, marginHorizontal: widthInPercentage(35) },
  flatlistStyle_LDPI: { flex: 1, marginHorizontal: widthInPercentage(28) },
  flatlistStyle_MDPI: { flex: 1, marginHorizontal: widthInPercentage(28) },
  flatlistStyle_XHDPI: { flex: 1, marginHorizontal: widthInPercentage(18) },
  flatlistStyle_HDPI: { flex: 1, marginHorizontal: widthInPercentage(18) },
  arrowView:
    { flex: 0.8 },
  arrowView_LAPTOP:
    { flex: 0.8 },
  arrowView_LDPI:
    { flex: 1 },
  arrowView_XHDPI:
    { flex: 1.5 },
  arrowView_XXXHDPI:
    { flex: 1 },
  arrowView_XXHDPI:
    { flex: 1 },
  serviceImageStyle: {
    height: 'auto',
    width: 14,
    padding: 10,
  },
  serviceImageStyle_LDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_MDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_HDPI: { height: 15, width: 15, padding: 15, },
  serviceImageStyle_XHDPI: { height: 14, width: 14, padding: 10 },
  serviceImageStyle_XXHDPI: { height: 15, width: 1, padding: 8 },
  serviceImageArrowStyle: {
    height: 14,
    width: 14,
    padding: 2,
    paddingBottom: 6,
  },
  serviceImageArrowStyle_LDPI: { height: 15, width: 15, padding: 15 },
  serviceImageArrowStyle_MDPI: { height: 15, width: 15, padding: 15 },
  serviceImageArrowStyle_HDPI: { height: 15, width: 15, padding: 15 },
  serviceImageArrowStyle_XHDPI: { height: 15, width: 15, padding: 10 },
  serviceImageArrowStyle_XXHDPI: { height: 10, width: 10, padding: 5 },
  serviceImageArrowStyleATM: { height: 15, width: 15, padding: 5 },
  serviceImageView: {
    flex: 1,
    marginVertical: '5%',
    marginLeft: widthInPercentage(2)
  },
  serviceImageView_LDPI: {
    marginVertical: '0%',
    alignItems: 'center',
    padding: 5
  },
  serviceImageView_MDPI: {
    marginVertical: '0%',
    alignItems: 'center',
    padding: 5
  },
  serviceImageView_HDPI: {
    marginVertical: '0%',
    alignItems: 'center',
    padding: 5
  },
  serviceImageView_XHDPI: {
    marginVertical: '1%',
    alignItems: 'center',
    padding: 1
  },
  serviceImageView_XXHDPI: {
    // marginVertical: '5%',
    paddingLeft: widthInPercentage(12),
    justifyContent: 'center',
    alignItems: 'left',
  },
  menuView: { borderBottomEndRadius: 3, borderTopLeftRadius: 3, width: widthInPercentage(12) },
  menuView_LAPTOP: { borderBottomEndRadius: 3, borderTopLeftRadius: 3, width: widthInPercentage(12) },
  menuView_LDPI: { borderBottomEndRadius: 3, borderTopLeftRadius: 3, },
  menuView_MDPI: { borderBottomEndRadius: 3, borderTopLeftRadius: 3, },
  menuView_HDPI: { borderBottomEndRadius: 3, borderTopLeftRadius: 3, },
  serviceMenuImageArrowStyle: {
    height: 10,
    width: 10,
    padding: 10,
    paddingBottom: 6,
  },
  serviceMenuImageArrowStyle_LDPI: { height: 15, width: 15, padding: 6 },
  serviceMenuImageArrowStyle_MDPI: { height: 15, width: 15, padding: 6 },
  sserviceMenuImageArrowStyle_HDPI: { height: 15, width: 15, padding: 6 },
  serviceMenuImageArrowStyle_XHDPI: { height: 15, width: 15, padding: 15 },
  serviceMenuImageArrowStyle_XXHDPI: { height: 15, width: 15, padding: 15 },
  serviceMenuBoxPadding: {
    padding: 10, height: '100%'
  },
  serviceMenuBoxPadding_LDPI: {
    padding: 10
  },
  serviceMenuBoxPadding_MDPI: {
    padding: 10
  },
  serviceMenuBoxPadding_HDPI: {
    //padding: 10
  },
  serviceMenuBoxPadding_XHDPI: {
    padding: 8
  },
  serviceMenuBoxPadding_XXHDPI: {
    padding: 10
  },
  serviceMenuBoxPadding_XXXHDPI: {
    padding: 15
  },
  serviceMenuText:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    color: '#222222',
    textAlign: 'left',
    fontSize: 15,
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceMenuDescText:
  {
    fontFamily: 'Mulish',
    marginLeft: widthInPercentage(1),
    textAlign: 'left',
    fontSize: 12,
    alignItems: 'center',
    justifyContent: 'center',
    color: '#7b7b7b'
  },
  loaderstyle: { marginHorizontal: widthInPercentage(30), flexDirection: 'row', marginVertical: widthInPercentage(10), justifyContent: 'center', alignItems: 'center' },
  loaderstyle_LDPI: { marginHorizontal: widthInPercentage(1), flexDirection: 'column', marginVertical: widthInPercentage(10), justifyContent: 'center', alignItems: 'center' },
  loaderstyle_MDPI: { marginHorizontal: widthInPercentage(1), flexDirection: 'column', marginVertical: widthInPercentage(10), justifyContent: 'center', alignItems: 'center', width: widthInPercentage(100) },
  loaderstyle_HDPI: { marginHorizontal: widthInPercentage(1), flexDirection: 'column', marginVertical: widthInPercentage(1), justifyContent: 'center', alignItems: 'center' },
  loaderstyle_XHDPI: { marginHorizontal: widthInPercentage(20), flexDirection: 'row', marginVertical: widthInPercentage(10), justifyContent: 'center', alignItems: 'center' },
  loaderstyle_XXHDPI: { marginHorizontal: widthInPercentage(20), flexDirection: 'row', marginVertical: widthInPercentage(1), justifyContent: 'center', alignItems: 'center', marginBottom: widthInPercentage(50) },
  loaderstyle_LAPTOP: { marginHorizontal: widthInPercentage(30), flexDirection: 'row', marginVertical: widthInPercentage(1), justifyContent: 'center', alignItems: 'center', },
  arrowsDate: { flexDirection: 'row', flex: 1.6, justifyContent: 'center', alignItems: 'center' },
  arrowsDate_XXXHDPI: { flexDirection: 'row', width: widthInPercentage(40), justifyContent: 'center', alignItems: 'center' },
  arrowsDate: { flexDirection: 'row', flex: 2, justifyContent: 'center', alignItems: 'center' },
  arrowsDate_XXHDPI: { flexDirection: 'row', flex: 3, justifyContent: 'center', alignItems: 'center' },
  logoDisplay: {
    display: 'flex',
    flexDirection: 'row',
  },
  logoInVerification: {
    display: 'flex',
    flexDirection: 'row',
    width: widthInPercentage(50),
  },
  iciciLogoWidth: {
    // width: '170px',
    // marginLeft: '4px',
    height: '50px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),

  },
  iciciLogoWidth_XHDPI: {
    // width: '95px',
    height: '55px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidth_XXHDPI: {
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
    height: '55px'
  },
  instaServeLogoWidth: {
    // width: '75px',
    // marginLeft: '5px',
    height: '60px',
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidth_XHDPI: {
    // width: '50px',
    // marginLeft: '3px',
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidth_XXHDPI: {
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  seconLayerLogo: {
    display: 'flex',
    flexDirection: 'row'
  },
  mobileDisplay: {
    width: '150px'
  },
  mobileDisplayInsta: {
    width: '100px'
  },
  iciciLogoWidth1: {
    // width: '160px',
    height: '47px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidth1_XHDPI: {
    // width: '90px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
    height: '62px'
  },
  instaServeLogoWidth1: {
    // width: '80px',
    marginLeft: '5px',
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidth1_XHDPI: {
    // width: '50px',
    // marginLeft: '5px',
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidth1_XXHDPI: {
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
    height: '62px'
  },
  instaServeLogoWidth1_XXHDPI: {
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidthParams: {
    // width: '150px',
    height: '50px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidthParams: {
    // width: '86px'
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidthParams_XXHDPI: {
    // width: '140px',
    height: '55px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidthParams_XXHDPI: {
    // width: '71px'
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidthParams_XHDPI: {
    // width: '93px',
    height: '62px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidthParams_XHDPI: {
    // width: '45px'
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  TopNavImage1StyleViewVeri: {
    resizeMode: 'contain',
    marginLeft: 10,
    width: widthInPercentage(50),
    //height: 72
  },
  TopNavImage1StyleViewVeri_XXHDPI: {
    resizeMode: 'contain',
    width: 160,
    height: 70
  },
  TopNavImage1StyleViewVeri_XHDPI: {
    resizeMode: 'contain',
    width: 140,
    height: 70
  },
  TopNavImage1StyleViewVeri_HDPI: {
    // resizeMode: 'contain',
    position: 'absolute',
    left: 140,
    top: 5,
    width: 120,
    height: 72,
  },
  TopNavImage1StyleViewVeri_MDPI: {
    // resizeMode: 'contain',
    position: 'absolute',
    left: 130,
    top: 5,
    width: 120,
    height: 72,
  },
  TopNavImage1StyleViewVeri_LDPI: {
    position: 'absolute',
    left: 130,
    width: 120,
    height: 72,
  },
  iciciLogoWidthveri: {
    // width: '170px',
    // marginLeft: '4px',
    height: '50px',
    width: widthInPercentage(40),
    marginHorizontal: widthInPercentage(4),

  },
  iciciLogoWidthveri_XHDPI: {
    // width: '95px',
    height: '55px',
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
  },
  iciciLogoWidthveri_XXHDPI: {
    width: widthInPercentage(50),
    marginHorizontal: widthInPercentage(4),
    height: '55px'
  },  
  instaServeLogoWidthveri: {
    // width: '75px',
    // marginLeft: '5px',
    height: '50px',
    width: widthInPercentage(30),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidthveri_XHDPI: {
    // width: '50px',
    // marginLeft: '3px',
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
  instaServeLogoWidthveri_XXHDPI: {
    width: widthInPercentage(35),
    marginHorizontal: widthInPercentage(4),
  },
});
